import { Checkbox } from "@b2bportal/core-ui";
import styles from "./styles.module.scss";
import {
  FieldValues,
  FieldPath,
  Path,
  useController,
  UseControllerProps,
} from "react-hook-form";
import { FormControlWrapper } from "@apac/form-ui";
import { useModuleBEM } from "@b2bportal/core-themes";

interface FormCheckboxProps<
  TFieldValues extends FieldValues,
  FName extends Path<TFieldValues>
> extends UseControllerProps<TFieldValues, FName> {
  label?: string;
}

export const FormCheckbox = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  rules,
  label,
  disabled,
}: FormCheckboxProps<TFieldValues, TName>): JSX.Element => {
  const [block, cn] = useModuleBEM(styles, "FormCheckbox");

  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  return (
    <FormControlWrapper error={fieldState.error?.message}>
      <div className={block}>
        <Checkbox
          id={name}
          name={name}
          checked={field.value}
          disabled={disabled}
          onCheckedChange={(checked) => {
            field.onChange(checked);
            field.onBlur();
          }}
        />
        <label htmlFor={name} className={cn("checkbox-label")}>
          {label}
        </label>
      </div>
    </FormControlWrapper>
  );
};
